import { getUserSummary } from './services';
import { IUserSummary } from './types';

const TTL_MS = 5 * 60 * 1000;
const TEAM_STORAGE_PREFIX = 'power-user-team:';
const NO_TEAM_SENTINEL = '__NONE__';

let cache: { data: IUserSummary[]; fetchedAt: number } | null = null;
let inflight: Promise<IUserSummary[]> | null = null;

export function clearUserSummaryCache(): void {
	cache = null;
	inflight = null;
	Object.keys(sessionStorage).forEach((key) => {
		if (key.startsWith(TEAM_STORAGE_PREFIX)) {
			sessionStorage.removeItem(key);
		}
	});
}

export async function fetchUserSummaryCached(): Promise<IUserSummary[]> {
	if (cache && Date.now() - cache.fetchedAt < TTL_MS) {
		return cache.data;
	}

	if (!inflight) {
		inflight = getUserSummary()
			.then((response) => {
				cache = { data: response.data, fetchedAt: Date.now() };
				inflight = null;
				return response.data;
			})
			.catch((error) => {
				inflight = null;
				throw error;
			});
	}

	return inflight;
}

/** `null` = not cached yet; `undefined` = cached as no team */
export function getCachedTeamForUsername(username: string): string | undefined | null {
	const stored = sessionStorage.getItem(`${TEAM_STORAGE_PREFIX}${username}`);
	if (stored === null) {
		return null;
	}
	return stored === NO_TEAM_SENTINEL ? undefined : stored;
}

export function setCachedTeamForUsername(username: string, team: string | undefined): void {
	sessionStorage.setItem(`${TEAM_STORAGE_PREFIX}${username}`, team ?? NO_TEAM_SENTINEL);
}
